export const bannerData = {
    title: {
        title1: "Abdul Kader",
        title2: "is a",
        title3: "Software Engineer",
        title4: "&",
        title5: "Frontend",
        title6: "Specialist",
    },

    subtitle: `Software Engineer with 4+ years of experience building scalable, high-performance web applications using React.js, Next.js, and TypeScript. Experienced in enterprise application development, modern frontend architecture, REST API integration, and delivering clean, responsive, and user-centric digital experiences.`,

    image: require("../assets/images/banner/banner.png"),

    doing: {
        text: "Software Engineer at",
        url: "https://ibos.io/",
        urlText: "Akij iBOS Limited",
        target: "_blank",
    },

    blockquote: {
        quoteText1: "First,",
        quoteText2: "solve the",
        quoteText3: "problem.",
        quoteText4: "Then, write the code.",
        quoteBy: "John Johnson",
    },
    // blockquote: {
    //     quoteText1: "Experience is",
    //     quoteText2: "the name",
    //     quoteText3: "everyone",
    //     quoteText4: "gives to their mistakes",
    //     quoteBy: "Oscar Wilde",
    // }
};